import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Dealers from "./pages/Dealers";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { HelmetProvider } from "react-helmet-async";
import { GlobalSEO } from "components/GlobalSEO";
import { BreadcrumbProvider } from "components/breadcrumb/BreadcrumbContext";
import Breadcrumb from "components/breadcrumb/Breadcrumb";
import { lazy, Suspense } from "react";

export default function App() {
  const AProposLazy = lazy(() => import("./pages/About"));
  const ContactLazy = lazy(() => import("./pages/Contact"));
  const MentionsLegalesLazy = lazy(() => import("./pages/MentionsLegales"));
  const PolitiqueConfidentialiteLazy = lazy(
    () => import("./pages/PolitiqueDeConfidentialite")
  );
  const ConditionsGeneralesLazy = lazy(
    () => import("./pages/ConditionsGenerales")
  );
  const NotFoundLazy = lazy(() => import("./pages/NotFound"));
  return (
    <HelmetProvider>
      <GlobalSEO />
      <BreadcrumbProvider>
        <div className="App">
          <Navbar />
          <main id="contenu" className="main container" role="main">
            <Breadcrumb />
            <Suspense fallback={null}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/produits" element={<Products />} />
                <Route path="/produits/:slug" element={<ProductDetail />} />
                <Route path="/revendeurs" element={<Dealers />} />
                <Route path="/a-propos" element={<AProposLazy />} />
                <Route path="/contact" element={<ContactLazy />} />
                <Route
                  path="/mentions-legales"
                  element={<MentionsLegalesLazy />}
                />
                <Route
                  path="/politique-confidentialite"
                  element={<PolitiqueConfidentialiteLazy />}
                />
                <Route
                  path="/conditions-generales"
                  element={<ConditionsGeneralesLazy />}
                />
                <Route path="*" element={<NotFoundLazy />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </BreadcrumbProvider>
    </HelmetProvider>
  );
}
